import { render, staticRenderFns } from "./OwnerTenanciesView.vue?vue&type=template&id=1a7bd0b3&scoped=true"
import script from "./OwnerTenanciesView.vue?vue&type=script&lang=js"
export * from "./OwnerTenanciesView.vue?vue&type=script&lang=js"
import style0 from "./OwnerTenanciesView.vue?vue&type=style&index=0&id=1a7bd0b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bd0b3",
  null
  
)

export default component.exports